// @flow

import _ from 'lodash/fp';
import React, {Component} from 'react';
import Dropzone from 'react-dropzone';
import FileUpload from '../FileUpload/FileUpload';
import './ImagesDropzone.css';
import {apiBase} from '../../helpers/request';

const fileUrl = `${apiBase}/files`;

export type Props = {
  images: any[],
  uploads: any[],
  onUpload: Function,
  onRemove: Function,
  onUploadAbort: Function,
};

class ImagesDropzone extends Component<Props> {
  props: Props;
  _dropzone: any;

  openDropzone() {
    if (this._dropzone) {
      this._dropzone.open();
    }
  }

  render() {
    const {
      images,
      uploads,
      onUpload,
      onRemove,
      onUploadAbort,
    } = this.props;

    return (
      <div className="ImagesDropzone">
        <Dropzone
          onDrop={files => onUpload(files)}
          disableClick={true}
          multiple={false}
          accept="image/*"
          ref={ref => this._dropzone = ref}
          className="zone">
          {_.map(image => (
            <div
              key={image.id}
              className="image">
              <div className="row no-row-margins align-middle expand">
                <div className="image-thumb column shrink">
                  <img
                    src={`${fileUrl}/preview/${image.id}/100x100`}
                    alt={image.name} />
                </div>
                <a
                  href={`${fileUrl}/${image.id}?download`}
                  target="_blank"
                  className="file-name column text-truncate">
                  {image.name + image.extension}
                </a>
                <button
                  onClick={() => onRemove(image)}
                  type="button"
                  className="button column shrink">
                  <i className="fa fa-trash"></i>
                </button>
              </div>
            </div>
          ), images)}
          {_.map(upload => (upload.progress < 100) && (
            <FileUpload
              key={upload.id}
              upload={upload}
              onUploadAbort={() => onUploadAbort(upload)}/>
          ), uploads)}
        </Dropzone>
        <button
          onClick={() => this.openDropzone()}
          type="button"
          className="button expanded">
          Ladda upp ny bild
        </button>
      </div>
    );
  }
}

export default ImagesDropzone;



// WEBPACK FOOTER //
// ./src/components/ImagesDropzone/ImagesDropzone.js